import { useContext } from "react";
import DataClientContext from "./DataClientContext";
import defaultClient from "./defaultClient";
export default function useDataClient() {
    const dataClient = useContext(DataClientContext);
    if (dataClient === defaultClient) {
        throw new Error('@sail/data revamp APIs have been used without it being initialized. Please check that you are rendering DataProvider with unstable_sail_data_revamp property set.');
    }
    return dataClient;
}

//# sourceMappingURL=useDataClient.js.map